import HistoryPlugin from './lib/index'

export default HistoryPlugin
